import * as _ from 'lodash';
import { FormEvent, useEffect, useState } from 'react';
import { IGpsDevice, IGpsItemsForList } from '@nkr/models/index';
import { Alert, Button, Col, ControlLabel, FormControl, FormGroup, Modal, Row, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import { GpsAction } from '../gps-action';
import usePrevious from '@nkr/services/use-previous';

interface IProps {
    show: boolean,
    gpsAction: GpsAction,
    data: IGpsItemsForList,
    gpsList: IGpsDevice[],
    onFieldChange: (field: string, value: any) => void,
    onConfirm: () => void,
    onCancel: () => void,
}

const ShipGps = (props: IProps) => {
    const [vendor, setVendor] = useState(-1);

    const [validation, setValidation] = useState({
        gpsNumber: true,
        gpsLink: true
    });

    const previousShow = usePrevious(props.show);

    useEffect(() => {
        if (previousShow == false && props.show) {
            setVendor(-1);
            setValidation({ gpsNumber: true, gpsLink: true });
        }
    }, [props.show]);

    const handleChangeVendor = (newVendor: number) => {
        setVendor(newVendor);
    };

    const handleFieldChange = (e: FormEvent<FormControl & HTMLInputElement & HTMLSelectElement>) => {
        let { name, value } = e.currentTarget;
        props.onFieldChange(name, value);
    };

    const handleConfirm = () => {
        let updatedValidation = {
            gpsNumber: props.data.gpsNumber != 0,
            gpsLink: props.data.gpsLink != '' || props.gpsAction == GpsAction.AddGpsNumber
        };

        let isValid = updatedValidation.gpsNumber && updatedValidation.gpsLink;

        setValidation(updatedValidation);

        if (isValid) {
            props.onConfirm();
        }
    };

    const handleCancel = () => {
        let updatedValidation = {
            gpsNumber: true,
            gpsLink: true
        };

        setValidation(updatedValidation);

        props.onCancel();
    };

    let swapNumber = props.data != null ? props.data.swapNumber : '';
    let gpsNumber = props.data != null ? props.data.gpsNumber : '';
    let gpsLink = props.data != null ? props.data.gpsLink : '';

    const isValid = validation.gpsNumber && validation.gpsLink;

    const gpsList = props.gpsList.filter(x => {
        let vendorFilter = vendor >= 0 ? x.vendorId == vendor : true;
        return vendorFilter;
    });

    const newGateCount = gpsList.filter(x => x.vendorId == 0).length;
    const btrackingCount = gpsList.filter(x => x.vendorId == 1).length;

    return (
        <Modal backdrop='static' show={props.show} onHide={handleCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Enter Journey Link</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {!isValid && (
                    <Alert bsStyle='danger' style={{ padding: '7.5px 15px' }}>
                        **All Fields Required** &nbsp;&nbsp;
                        Please correct the issues below...
                    </Alert>
                )}

                <Alert bsStyle='info' style={{ paddingTop: 7.5, paddingBottom: 7.5 }}>
                    <Row>
                        <Col xs={12} lg={1}>Swap:</Col>
                        <Col xs={12} lg={10}>{swapNumber}</Col>
                    </Row>
                    <Row>
                        <Col xs={12} lg={1}>GPS:</Col>
                        <Col xs={12} lg={10}>{gpsNumber}</Col>
                    </Row>
                </Alert>

                {props.gpsAction == GpsAction.AddGpsNumber && (
                    <FormGroup validationState={validation.gpsNumber ? null : 'error'}>
                        <ControlLabel style={{ width: '100%' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div>GPS #:</div>
                            </div>
                        </ControlLabel>
                        <FormControl
                            componentClass='select'
                            name='gpsNumber'
                            value={gpsNumber}
                            onChange={handleFieldChange}
                        >
                            <option value={0}>- Select -</option>
                            {gpsList.map(device =>
                                <option key={'gps-dev-' + device.id} value={device.id}>{device.gpsNumber} ({device.vendor})</option>
                            )}
                        </FormControl>
                    </FormGroup>
                )}

                {props.gpsAction == GpsAction.MarkActive && (
                    <FormGroup validationState={validation.gpsLink ? null : 'error'}>
                        <ControlLabel>Enter the journey link:</ControlLabel>
                        <FormControl
                            id='gpsLink'
                            name='gpsLink'
                            style={{ width: '100%' }}
                            placeholder='Enter journey link'
                            value={gpsLink}
                            onChange={handleFieldChange}
                        />
                    </FormGroup>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={handleConfirm}>{props.gpsAction == GpsAction.MarkActive ? 'Mark as Active' : 'Mark as Shipped'}</Button>
                <Button onClick={handleCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ShipGps;